<template>
    <div v-if="'password' in model" class="wrapper">
        <item-form
                :model="model"
                @activate="activateAccount">
        </item-form>

        <b-modal title="Activeren" size="sm" class="modal-danger" v-model="foutModal" @ok="closedialog">
            FOUT: Account werd niet geactiveerd! {{errormsg}}
        </b-modal>

        <b-modal title="Activeren" size="sm" v-model="okModal" @ok="closeOKdialog" @hidden.bs.modal="goback">
            Account werd geactiveerd!
        </b-modal>

        <b-modal title="Activeren" size="sm" v-model="okMailModal" @ok="closeOKdialog" @hidden.bs.modal="goback">
            Account werd geactiveerd! Het wachtwoord werd gemaild naar het e-mailadres van de gebruiker.
        </b-modal>
    </div>
</template>

<script>
    import api from '../../api/account';
    import pwfunctions from '../../helpers/pwfunctions';
    import ItemForm from './MailForm';

    export default {
        data () {
            return {
                foutModal: false,
                okModal: false,
                okMailModal: false,
                errormsg: '',
                model: {
                    typeuser: {},
                },
            };
        },
        created () {
            api.getDetailUser(this.$route.params.id).then((response) => {
                this.model = response.data.model;
                this.model.password = pwfunctions.makepw();
                this.model.sendmail = true;
            });
        },
        methods: {
            activateAccount (model) {
                api.updatePassword(model).then(() => {
                    if (this.model.sendmail) {
                        api.sendMail(model).then(() => {
                                this.okMailModal = true;
                            },
                            (error) => {
                                this.errormsg = error.message;
                                this.foutModal = true;
                            });
                    } else {
                        this.okModal = true;
                    }
                },
                (error) => {
                    this.errormsg = error.message;
                    this.foutModal = true;
                });
            },
            closedialog () {
                this.foutModal = false;
            },
            closeOKdialog () {
                this.okModal = false;
                // this.$router.replace('/beheer/account');
            },
            goback () {
                this.$router.replace('/beheer/account');
            },
        },
        components: {
            'item-form': ItemForm,
        },
    };
</script>



// WEBPACK FOOTER //
// src/pages/account/Activate.vue